import React from 'react';
import DrawingResult from "./DrawingResult";
import DrawingResultCircle from "./../lotto12v3/DrawingResult";
import BettingBoard from "./BettingBoard";
import Balance from "../../pages/components/Balance";
import RecentOrdering from "./RecentOrdering";
import _ from "lodash";
import BettingDialog from "../lotto5/BettingDialog";
import RecentBetting from "./RecentBetting";
import {lotto12DrawStyle} from "../../constants/general";
import {useLotto12v2} from "../../store/lotto12v2/Lotto12v2Context";

const LeftSideWrapper = (props) => {
    const lotto = useLotto12v2()
    return <LeftSide {...lotto} {...props}/>
}

class LeftSide extends React.Component {

    render() {
        const {
            user: {userBalance, isAddToCart},
            betting,
            drawStyle,
            showConfirmDelete,
            isEnableBetNow,
            submitBetNow,
            afterPrint,
            changeBetAmount,
            clickAmountBetBtn,
            onConfirmBetting,
            resetDefaultAmount,
            onCancelBetting,
            onBetting
        } = this.props;

        return (
            <div className="l-side">
                <div className="d-flex">
                    <div className="lotto12v2-h-vw border">

                        {/* user balance */}
                        <Balance pendingAmount={userBalance.pendingYuki}/>
                        {/* End of user balance */}

                        {/*/!* Recent Ordering *!/*/}
                        {(!_.isEmpty(betting.betList) && isAddToCart) &&
                        <RecentOrdering
                            showConfirmDelete={showConfirmDelete}
                            isEnableBetNow={isEnableBetNow}
                            submitBetNow={submitBetNow}
                            {...this.props}/>}
                        {/*/!* End of recent ordering *!/*/}

                        {/*/!* Recent betting *!/*/}
                        <RecentBetting afterPrint={afterPrint} {...this.props}/>
                        {/*/!* End of recent betting *!/*/}

                    </div>
                    <div>
                        {drawStyle === lotto12DrawStyle.square && <DrawingResult/>}
                        {drawStyle === lotto12DrawStyle.circle && <DrawingResultCircle/>}
                        <BettingBoard onBetting={onBetting}/>
                    </div>
                </div>
                <BettingDialog changeBetAmount={changeBetAmount}
                               clickAmountBetBtn={clickAmountBetBtn}
                               onConfirmBettingLotto5={onConfirmBetting}
                               resetDefaultAmount={resetDefaultAmount}
                               onCancelBetting={onCancelBetting}
                               {...this.props}/>


            </div>
        );
    };
}

export default LeftSideWrapper;

